import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
import { SERVICES } from "../../data/services";
import { CONTACT, IMAGES } from "../../data/constants";
import "./Contact.css";

function Contact() {
  const { t } = useTranslation();

  const [form, setForm] = useState({ name: "", email: "", phone: "", service: "", message: "" });
  const [sent, setSent] = useState(false);

  const handle = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = () => {
    if (form.name && form.email && form.message) setSent(true);
  };

  return (
    <div className="contact-page" style={{ paddingTop: 66 }}>

      {/* Hero */}
      <div className="page-hero contact-page__hero">
        <img src={IMAGES.contact} alt="Contact SK Associate — concrete floor solutions" className="hero-bg" />
        <div className="hero-overlay" style={{ background: "rgba(0,0,0,0.82)" }} />
        <div className="hero-content container">
          <p className="section-label">{t("contact_page.label")}</p>
          <h1 className="contact-page__title">{t("contact_page.title")}</h1>
        </div>
      </div>

      {/* Quick contact strip */}
      <div className="contact-page__strip">
        {[
          ["📞", "+91-9950817883"],
          ["📞", "+91-7737817883"],
          ["✉",  "info@skassociate.co"],
          ["🌐", "www.skassociate.co"],
        ].map(([ico, val]) => (
          <div key={val} className="contact-page__strip-item">
            <span>{ico}</span>
            <span>{val}</span>
          </div>
        ))}
      </div>

      {/* Form + Info */}
      <section className="section" style={{ background: "var(--bg2)" }}>
        <div className="container contact-page__grid">

          {/* Form */}
          <AnimatedSection>
            {sent ? (
              <div className="contact-page__success">
                <span className="contact-page__success-icon">✅</span>
                <h3 className="contact-page__success-title">{t("contact_page.success.title")}</h3>
                <p className="contact-page__success-sub">
                  {t("contact_page.success.sub")}
                </p>
              </div>
            ) : (
              <div className="contact-page__form-card">
                <h2 className="contact-page__form-title">{t("contact_page.form.heading")}</h2>

                <div className="contact-page__row">
                  <div className="contact-page__field">
                    <label className="contact-page__label">{t("contact_page.form.name_label")}</label>
                    <input
                      name="name"
                      value={form.name}
                      onChange={handle}
                      placeholder={t("contact_page.form.name_placeholder")}
                      className="contact-page__input"
                    />
                  </div>

                  <div className="contact-page__field">
                    <label className="contact-page__label">{t("contact_page.form.email_label")}</label>
                    <input
                      name="email"
                      value={form.email}
                      onChange={handle}
                      placeholder={t("contact_page.form.email_placeholder")}
                      className="contact-page__input"
                    />
                  </div>
                </div>

                <div className="contact-page__row">
                  <div className="contact-page__field">
                    <label className="contact-page__label">{t("contact_page.form.phone_label")}</label>
                    <input
                      name="phone"
                      value={form.phone}
                      onChange={handle}
                      placeholder={t("contact_page.form.phone_placeholder")}
                      className="contact-page__input"
                    />
                  </div>

                  <div className="contact-page__field">
                    <label className="contact-page__label">{t("contact_page.form.service_label")}</label>
                    <select
                      name="service"
                      value={form.service}
                      onChange={handle}
                      className="contact-page__input contact-page__select"
                    >
                      <option value="">{t("contact_page.form.service_placeholder")}</option>
                      {SERVICES.map((s) => (
                        <option key={s.id} value={s.id}>{s.title}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="contact-page__field" style={{ marginBottom: 22 }}>
                  <label className="contact-page__label">{t("contact_page.form.message_label")}</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handle}
                    placeholder={t("contact_page.form.message_placeholder")}
                    rows={5}
                    className="contact-page__input contact-page__textarea"
                  />
                </div>

                <button className="btn-primary contact-page__submit" onClick={submit}>
                  {t("contact_page.form.submit")}
                </button>
              </div>
            )}
          </AnimatedSection>

          {/* Info */}
          <AnimatedSection delay={0.2}>
            <div className="contact-page__info">
              <h2 className="contact-page__info-title">{t("contact_page.info.heading")}</h2>

              {[
                ["📍", t("contact_page.info.office_title"), `${CONTACT.address1}\n${CONTACT.address2}\n\n${CONTACT.address3}`],
                ["📞", t("contact_page.info.phone_title"), CONTACT.phones.join("\n")],
                ["✉",  t("contact_page.info.email_title"), CONTACT.emails.join("\n")],
                ["🌐", t("contact_page.info.website_title"), CONTACT.website],
              ].map(([icon, title, content]) => (
                <div key={title} className="contact-page__info-row">
                  <div className="contact-page__info-icon">{icon}</div>
                  <div>
                    <p className="contact-page__info-label">{title}</p>
                    <p className="contact-page__info-val">{content}</p>
                  </div>
                </div>
              ))}

              {/* Map */}
              <div className="contact-page__map">
                <img
                  src={IMAGES.factory}
                  alt="SK Associate location — India industrial corridor"
                  className="contact-page__map-img"
                />
                <div className="contact-page__map-overlay">
                  <span className="contact-page__map-pin">🗺️</span>
                  <p className="contact-page__map-title">{t("contact_page.info.map_city")}</p>
                  <p className="contact-page__map-sub">{t("contact_page.info.map_sub")}</p>
                </div>
              </div>
            </div>
          </AnimatedSection>

        </div>
      </section>
    </div>
  );
}

export default Contact;